import { createApp } from 'vue'
import App from './App.vue'
import store from './store.js'
import router from './router'
import PrimeVue from 'primevue/config';
import {Circle4} from 'vue-loading-spinner'
import InputNumber from 'primevue/inputnumber';
import InputText from 'primevue/inputtext';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import ColumnGroup from 'primevue/columngroup';   // optional
import Row from 'primevue/row';                   // optional

 
//import "devextreme/dist/css/dx.light.css";
//import "@devexpress/analytics-core/dist/css/dx-analytics.common.css";
//import "@devexpress/analytics-core/dist/css/dx-analytics.light.css";
//import "devexpress-reporting/dist/css/dx-webdocumentviewer.css";

import apiPlugin from './components/func/api.js';
import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';
import 'primevue/resources/themes/saga-green/theme.css';
 
const app = createApp(App);
app.use(store);
app.use(router);
app.use(PrimeVue, { ripple: true  });
app.use(apiPlugin, store);
app.component('Circle4', Circle4);
app.component('InputNumber', InputNumber);
app.component('InputText', InputText);
app.component('DataTable', DataTable);
app.component('Column', Column);
app.component('ColumnGroup', ColumnGroup);
app.component('Row', Row);

 
app.mount('#app');
